import { useFeatures } from './useFeatures.js';
const useAppModule = () => {
  const modules = useFeatures();
  let currentFeature;
  const appModule = modules == null ? void 0 : modules.find(module => {
    var _a, _b;
    currentFeature = (_b = (_a = module.features) == null ? void 0 : _a.filter(f => f.url)) == null ? void 0 : _b.find(menu => window.location.pathname.indexOf(menu.url) === 0 || window.location.hash.indexOf(menu.url) === 1);
    return !!currentFeature;
  });
  return {
    currentFeature,
    appModule
  };
};
export { useAppModule as default };